import { IconButton, type IconButtonProps } from '@chakra-ui/react';
import type React from 'react';

export interface FaceliftIconButtonProps extends IconButtonProps {
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	sx?: React.CSSProperties;
	buttonKey?: string;
	bg?: string;
	color?: string | { _dark: string; _light: string };
	ref?: React.RefObject<HTMLButtonElement | null>;
}

const FaceliftIconButton: React.FC<FaceliftIconButtonProps> = ({
	onClick,
	sx,
	buttonKey,
	bg = 'brand.solidGradient',
	color = 'brand.muted',
	children,
	ref,
	...rest
}) => {
	return (
		<IconButton
			ref={ref}
			size="sm"
			bg={bg}
			color={color}
			key={buttonKey}
			onClick={onClick}
			display="inline-flex"
			alignItems="center"
			borderRadius="20px"
			style={sx}
			// _hover={{ bg: 'brand.solidGradient', color: 'white' }}
			{...rest}
		>
			{children}
		</IconButton>
	);
};

export default FaceliftIconButton;
